import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '@app/core/services/http';

export const countryAccessInterceptorFn: HttpInterceptorFn = (req, next) => {
  const userHttpService = inject(UserService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (isCountryAccessError(error)) {
        userHttpService.getUsersInfo().subscribe(() => {
          window.location.reload();
        });
      }

      return throwError(() => error);
    })
  );
};

function isCountryAccessError(error: HttpErrorResponse): boolean {
  const errorMessage = error.error?.message || error.message || '';

  return (
    errorMessage.includes('Admin does not have access to this country') ||
    errorMessage.includes('admin does not have access to this country') ||
    errorMessage.includes('Admin does not have access to this country') ||
    errorMessage.includes('ADMIN DOES NOT HAVE ACCESS TO THIS COUNTRY')
  );
}
